module.exports = __webpack_public_path__ + "img/fox-sports.f8c21d92.png";